import React, { Component } from "react";
import colors from "../../colors";
// import menu from "../data/data";//menu
import Slider from "./Slider";

import ReactHtmlParser from "react-html-parser";
const home =
  '<ul> <li style="text-align: justify;">To develop medium-range flood early warning models for the major floodplains of two study river basins using space based inputs through hydrological modelling approach. (Godavari and Tapti Basins are identified for the study)</li> </ul> <ul style="text-align: justify;"> <li>To develop spatial flood inundation simulation models using high resolution DEM in the major floodplains of the rivers.</li> </ul> <ul style="text-align: justify;"> <li>To develop web-enabled real-time spatial flood early warning system</li> </ul> <ul style="text-align: justify;"> <li>To develop workflow for issuing flood advisory to the concerned disaster management authorities during the flood event.</li> </ul> <ul> <li style="text-align: justify;">Generation of flood inundation scenarios in the main flood-plains of the rivers under different flood return periods</li> </ul>';

export default class FLProjObjective extends Component {
  render() {
    return (
      <div
      className=" cardeck_full"
     
    >
      <div className="carddeck_inner"
        style={{
        
          backgroundColor: colors.background,
        }}
      >
          <Slider />
          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div
              className="card"
              style={{ padding: "15px", width: "100%", height: "100%" }}
            >
              {/* <main style={{flexGrow: "1", width:"100%", height:"100%", flexGrow:1, flexBasis:"content", alignSelf:"bsaeline"}}>
      <div className="card"> */}
              <div className="card-body">
                <h3 className="card-title" style={{ color: "#002171" }}>
                  Real-time Operational Spatial Flood Early Warning System
                  Development
                </h3>
                <hr />
                {ReactHtmlParser(home)}
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
